module.exports = __webpack_public_path__ + "img/beian-icon.d0289dc0.png";